import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Default error message to show when something goes wrong
const commonErr = "OOPS! something went wrong!";

// Set to keep track of currently displayed toasts to limit the number of toasts
const toastList = new Set();

// Maximum number of toasts allowed to be displayed at one time
const MAXIMUM_TOAST = 1;

/**
 * Function to show different types of alerts (toasts) based on the type parameter
 * @param {number} type - The type of alert to show (1: success, 2: error, 3: info, 4: dark, 5: general error)
 * @param {string} message - The message to display in the alert. Defaults to commonErr if not provided.
 */
export const showAlert = (type: number, message: string = commonErr) => {
  // Ensure the toast object has the error method defined before using it
  if (toast.error === undefined) {
    toast(message, {
      position: "top-right",
      autoClose: 3000,
      draggable: false,
      closeOnClick: true,
    });
  }

  switch (type) {
    case 1: {
      // Success toast
      if (toastList.size < MAXIMUM_TOAST) {
        const id: any = toast.success(message, {
          onClose: () => toastList.delete(id), // Remove toast from set when it closes
          icon: false, // No icon
          className:
            ".Toastify__toast--success toast-info-container toast-info-container-after",
          position: "top-right",
        });
        toastList.add(id); // Add toast ID to the set
      }
      break;
    }
    case 2: {
      // Error toast
      if (toastList.size < MAXIMUM_TOAST) {
        const id: any = toast.error(message, {
          onClose: () => toastList.delete(id), // Remove toast from set when it closes
          className:
            ".Toastify__toast--error toast-info-container toast-info-container-after",
          position: "top-right",
          icon: false, // No icon
        });
        toastList.add(id); // Add toast ID to the set
      }
      break;
    }
    case 3: {
      // Info toast
      if (toastList.size < MAXIMUM_TOAST) {
        const id: any = toast.info(message, {
          onClose: () => toastList.delete(id), // Remove toast from set when it closes
          position: "top-right",
        });
        toastList.add(id); // Add toast ID to the set
      }
      break;
    }
    case 4: {
      // Dark theme toast
      if (toastList.size < MAXIMUM_TOAST) {
        const id = toast.dark(message, {
          onClose: () => toastList.delete(id), // Remove toast from set when it closes
          className: "hide-alert",
          position: "top-right",
        });
        toastList.add(id); // Add toast ID to the set
      }
      break;
    }
    case 5: {
      // General error toast
      const id: any = toast.error(message, {
        onClose: () => toastList.delete(id), // Remove toast from set when it closes
        className:
          ".Toastify__toast--error toast-info-container toast-info-container-after",
        position: "top-right",
        icon: false, // No icon
      });
      toastList.add(id); // Add toast ID to the set
      break;
    }
    default: // If the type doesn't match any case, do nothing
  }
};
